import React from 'react';
import TabContent from './TabContent';
import TabHeader from './TabHeader';
import { ITabs } from './tabs.schema';
import "./Tabs.scss";

const Tabs:React.FC<ITabs> = (props:ITabs) => {
    return (
        <div className="tabs-wrapper">
            <TabHeader {...props} />
            <TabContent>
                {props.children}
            </TabContent>
        </div>
    );
} 

export default Tabs;